import { registerView, View } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Button, Col, Row } from "react-bootstrap";
import ChargeManagementReceiptViewModel from "../../../viewModels/chargeManagement/chargeManagementEdit/chargeManagementReceiptViewModel";
import { turnstileSiteKey } from "../../../config";
import Portal from "../../eshop/order/components/portal";
import Icon, { IconType } from "@edaz/edazkit/Icon";

const ChargeReceiptView: FunctionComponent<{
  vm: ChargeManagementReceiptViewModel;
}> = observer(({ vm }) => (
  <>
    <Col>
      <>
        <View vm={vm.turnstileViewModel} />
        <Row className="mb-3">
          <Button
            variant="link"
            onClick={async () => {
              if (vm.turnstileViewModel?.turnstileRef?.current?.execute) {
                vm.turnstileViewModel.showInteractive = true;
                vm.turnstileViewModel.onTurnstileLoad();

                await vm.turnstileViewModel.turnstileRef.current.execute();
                const token = await vm.turnstileViewModel.turnstileRef.current.getResponsePromise();
                if (token) {
                  vm.turnstileViewModel.onSetInfo(vm.turnstileViewModel.translateTurnstile("success"));
                  vm.downloadPaymentConfirmation(token);
                }
              }
            }}
            className="d-flex align-items-center box-shadow-none p-0 no-border-radius font-weight-normal text-body text-left link-underline text-wrap">
            <div
              className="d-flex align-items-center justify-content-center bg-primary mr-3 rounded-circle text-white"
              style={{ height: 40, width: 40, minWidth: 40 }}>
              <Icon icon={IconType.Pdf} width={20} height={20} />
            </div>
            {vm.translate("receipt.downloadReceiptInPDF")}
          </Button>
        </Row>
        <Row>
          <Button
            variant="link"
            onClick={async () => {
              if (vm.turnstileViewModel?.turnstileRef?.current?.execute) {
                vm.turnstileViewModel.showInteractive = true;
                vm.turnstileViewModel.onTurnstileLoad();
                await vm.turnstileViewModel.turnstileRef.current.execute();
                const token = await vm.turnstileViewModel.turnstileRef.current.getResponsePromise();
                if (token) {
                  vm.turnstileViewModel.onSetInfo(vm.turnstileViewModel.translateTurnstile("success"));
                  vm.sendPaymentConfirmationEmail(token);
                }
              }
            }}
            className="d-flex align-items-center box-shadow-none p-0 no-border-radius font-weight-normal text-body text-left link-underline text-wrap">
            <div
              className="d-flex align-items-center justify-content-center bg-primary mr-3 rounded-circle text-white"
              style={{ height: 40, width: 40, minWidth: 40 }}>
              <Icon icon={IconType.MailOpen} width={20} height={20} />
            </div>
            {vm.translate("receipt.sendReceiptToEmail")}
          </Button>
          {vm.showModal && <View vm={vm.emailInputViewModel} />}
        </Row>
      </>
    </Col>
  </>
));

registerView(ChargeReceiptView, ChargeManagementReceiptViewModel);
